// extracted by mini-css-extract-plugin
export default {"input":"L8-z","button":"M8-z","selected":"N8-z","unavailable":"O8-z","oos":"P8-z","image":"Q8-z","paperCutDisabledOverlay":"R8-z"};